import React from 'react'
import './About.css';

const About = () => {
  return (
    <div id='about' className='about'>
        <div className='about-title'>
            <h1>About me</h1>
            {/* moge image dać */}
        </div>
        <div className='about-sections'>
            <div className="about-left">
                {/* Image */}
            </div>
            <div className="about-right">
                <div className="about-para">
                    <p>
                        I am a driven <strong>Cybersecurity</strong> student at UITM in Rzeszów, building upon a solid software development foundation in .NET, React, and Python. My primary focus has shifted towards securing digital landscapes, with a deep interest in <strong>Cloud Computing</strong> and <strong>DevOps</strong> methodologies to ensure secure and automated deployment pipelines.
                    </p>
                    <p>
                        I am actively expanding my expertise in <strong>Computer Networking</strong> and <strong>Pentesting</strong>, focusing on vulnerability assessment and system hardening. Exploring the complexities of cloud infrastructure and identifying potential security flaws allows me to approach technology with both a developer's creativity and a security researcher's scrutiny.
                    </p>
                    <p>
                        Beyond my technical toolkit, I possess strong analytical skills and a collaborative mindset. My goal is to leverage my background in programming and my passion for <strong>Cybersecurity</strong> to contribute to meaningful projects, staying ahead of emerging threats and building resilient, real-world solutions.
                    </p>
                </div>
                <div className="about-skills">
                    <div className="about-skill"><p>.NET</p><hr style={{width:'70%'}}/></div>
                    <div className="about-skill"><p>React JS</p><hr style={{width:'58%'}}/></div>
                    <div className="about-skill"><p>JavaScript</p><hr style={{width:'50%'}}/></div>
                    <div className="about-skill"><p>Python</p><hr style={{width:'54%'}}/></div>
                    <div className="about-skill"><p>Next.js</p><hr style={{width:'70%'}}/></div>
                    <div className="about-skill"><p>Java</p><hr style={{width:'60%'}}/></div>
                </div>
            </div>
        </div>
        {/* <div className="about-achievements">
            <div className="about-achievement">
                <h1>1</h1>
                <p>cos</p>
            </div>
            <hr />
            <div className="about-achievement">
                <h1>1</h1>
                <p>cos</p>
            </div>
            <hr />
            <div className="about-achievement">
                <h1>1</h1>
                <p>coś</p>
            </div>
        </div> */}
    </div>
  )
}

export default About